export const InternReportFormFormat = function (blueprint, form_data = {}) {
  return {
    header_sq: header(form_data),
    content_sq: page(blueprint, form_data),
  };
}
function header(form_data) {
  return [
    {
      w: '100%', h: 50, text: '學生校外實習報告',
      border_width: 0, font_size: 21, font_family: '標楷體',
    },
  ];
}

function page(blueprint, form_data) {
  return [
    {
      w: '100%', h: 30, text: '一、基本資料',
      border_width: 0, align: 'left', font_family: '標楷體',
    },

    { w: '18%', h: 30, text: '學年期' },
    { w: '32%', h: 30, text: form_data.year },
    { w: '18%', h: 30, text: '課名' },
    { w: '32#', h: 30, text: form_data.course_title },

    { w: '18%', h: 30, text: '姓名' },
    { w: '32%', h: 30, text: form_data.student_name },
    { w: '18%', h: 30, text: '學號' },
    { w: '32%', h: 30, text: form_data.student_account },

    { w: '18%', h: 30, text: '就讀系所' },
    { w: '32%', h: 30, text: form_data.department_id },
    { w: '18%', h: 30, text: '系級' },
    { w: '32%', h: 30, text: form_data.department_grade },

    { w: '18%', h: 30, text: '實習機構' },
    { w: '32%', h: 30, text: form_data.internship },
    { w: '18%', h: 30, text: '實習輔導老師' },
    { w: '32%', h: 30, text: form_data.intern_teacher },

    {
      w: '100%', h: 30, text: '二、實習工作計畫表',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    { article: form_data.intern_form },

    {
      w: '100%', h: 30, text: '三、前言',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    { article: form_data.foreword },

    {
      w: '100%', h: 30, text: '四、本文',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    { article: form_data.content },

    {
      w: '100%', h: 30, text: '五、建議與心得',
      border_width: 0, align: 'left', font_family: '標楷體',
    },
    { article: form_data.report },
  ];
}

function check_radio_table(items, values) {
  return items.map((item, index) => {
    return [
      { w: '70%', h: 30, padding: 10, align: 'left', text: item },
      { w: '30%', h: 30, padding: 10, texts: values[index] },
    ];
  }).flat();
}

// 通用
function other_str(value) {
  return (value ? '☑': '☐') + ' 其他：' + (value || "____________________");
}
function date_to_str(date_str) {
  if(!date_str) return ' - ';
  let nd = new Date(date_str);
  return `${nd.getFullYear() - 1911} 年 ${nd.getMonth() + 1} 月 ${nd.getDate()} 日`;
}
function date_to_str_yyyy_mm_dd(date_str) {
  if(!date_str) return ' - ';
  let nd = new Date(date_str);
  return [
    nd.getFullYear(),
    ("0" + (nd.getMonth() + 1)).substr(-2),
    ("0" + nd.getDate()).substr(-2),
  ].join('/');
}